import { render, staticRenderFns } from "./SelectAnotherProjectModal.vue?vue&type=template&id=37cfb2c6"
import script from "./SelectAnotherProjectModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectAnotherProjectModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SelectAnotherProjectModal.vue?vue&type=style&index=0&id=37cfb2c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports